import ColumnName from './ColumnName';
export default ColumnName;
